const styles = {
    goldenText:
        "golden-text-main",
  };
  
  export { styles };